<script lang="ts" setup>
  import { useSnackbar } from '@/composables/useSnackbar'

  const {
    snackbarVisible,
    snackbarText,
    snackbarColor,
    snackbarTimeout,
    snackbarPosition,
    hideSnackbar,
  } = useSnackbar()
</script>

<template>
  <v-snackbar
    v-model="snackbarVisible"
    :color="snackbarColor"
    :location="snackbarPosition"
    :timeout="snackbarTimeout"
  >
    {{ snackbarText }}
    <template #actions>
      <v-btn icon="mdi-close" size="small" variant="text" @click="hideSnackbar" />
    </template>
  </v-snackbar>
</template>
